import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { removeEmpty } from "../utils/objectUtils";
import { notificationError, notificationSucces } from "./notification";

export async function getQueueStatus() {
    let res = [
        {
            name: "",
            executing: "-",
            size: 0,
            queueStatus: []
        }
    ];
  
    await Api.get(endpoints.getQueueStatus).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not get queue')
    })
  
    return res
  }
  